import React, { useEffect, useState, useRef } from "react";
import { useUiState } from "./../../../helpers/useUiState";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import BgImage from "assets/img/bg-image.png";
import { Button, Form, Grid, Input, theme, Typography, Select } from "antd";
import { useAuthProvider } from "./../../Auth/hooks/useAuthProvider";
import { useAuthSrv } from "pages/Auth/hooks/useAuthSrv";
import { useSessionDetailLog } from "helpers/useSessionDetailLog";
import {
  setLocalStore,
  getLocalStore,
  removeLocalStore,
} from "helpers/localStoreSrv";
import { InputOTP } from "antd-input-otp";
import i18n from "i18next";

import whitelabelConfig from "@whitelabel-config";

import { useTranslation } from "react-i18next";
import { Alert, Space } from "antd";

import otpConfig from "../meta_config.json";
import { portalActions } from "store/portal-slice";
import AppLogo from "./../../../components/AppLogo/AppLogo";
import BrandColors from "@brand-colors";
import { LANGUAGES } from "../../../constants/supported_lang";
import "./Auth.css";
import ReactGA from "react-ga";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import OtpInput from "./OtpInput";
import { usePageTitle } from "helpers/usePageTitle";
const { Option } = Select;
type ErrorState = {
  isError: boolean;
  errMsg: string;
};

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text } = Typography;
const initialErrorState: ErrorState = {
  isError: false,
  errMsg: "",
};
const AuthPage = () => {
  const portalSessionMeta = useSelector(
    (state: any) => state.portal.micrositeSession
  );
  const portalAuthSessionMeta = useSelector(
    (state: any) => state.portal.authSession
  );
  const { isAppLoading } = useUiState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otpValues, setOtpValues] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOtpError, setIsOtpError] = useState(initialErrorState);
  const [selectedLanguage, setSelectedLanguage] = useState("en"); // Default to English
  const surveyLanguage = useSelector(
    (state: any) => state.portal.uiState.SurveyLanguage
  );
  console.log("surveyLanguage", surveyLanguage);
  const [selectedLanguageForDropdown, setselectedLanguageForDropdown] =
    useState(surveyLanguage || "en");
  const [isRightAlign, setIsRightAlign] = useState(false);
  const { state } = useLocation();
  const { authStep } = state;
  const { generate2faOTP, verifyOTP, generateEmailPhoneOTP, midAuthenticatOTP, verifyMedicaidOTP } = useAuthSrv();
  const { updateAuthSession, updateAuthWizard } = useAuthProvider();
  const { logSessionDetail } = useSessionDetailLog();
  const { token } = useToken();
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const [isHover, setIsHover] = useState(false);
  const [authFlow, setAuthFlow] = useState(whitelabelConfig.authFlow);
  const currAuthFlow = authFlow["DEFAULT"];
  const inputRef = useRef<HTMLInputElement>(null);
  const languageSelectWrapperRef = useRef<HTMLDivElement>(null);
  const [otp, setOtp] = useState("");
  const onChange = (value: string) => setOtp(value);

  // Keep aria-controls valid AND present at all times (WCAG 4.1.2 / role=combobox):
  const LANGUAGE_LISTBOX_PLACEHOLDER_ID = "select-language_list_placeholder";
  const syncLanguageSelectAriaControls = (open: boolean) => {
    const wrapper = languageSelectWrapperRef.current;
    if (!wrapper) return;
    const input = wrapper.querySelector('input[role="combobox"]');
    if (!input) return;
    if (open) {
      const inputId = input.getAttribute("id");
      if (inputId) input.setAttribute("aria-controls", `${inputId}_list`);
    } else {
      input.setAttribute("aria-controls", LANGUAGE_LISTBOX_PLACEHOLDER_ID);
    }
  };
const getBrowserRole = () => {
  const ua = navigator.userAgent;

  // Edge (Chromium-based) — must check before Chrome, since Edge UA also contains "Chrome"
  if (ua.includes("Edg/") || ua.includes("Edge/")) {
    return "code";
  }

  // Chrome (and other Chromium browsers not explicitly excluded)
  if (ua.includes("Chrome/")) {
    return "application";
  }

  // fallback for anything else
  return undefined;
};
const role = getBrowserRole();
  useEffect(() => {
    syncLanguageSelectAriaControls(false);
  }, [portalSessionMeta.urlRef]);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  useEffect(() => {
    dispatch(portalActions.updateAuthWizard(currAuthFlow));
  }, []);
  usePageTitle("AUTH2FA.PAGE_TITLE", `Login - ${process.env.REACT_APP_PRODUCT}`);
  useEffect(() => {
    if (surveyLanguage) {
      setselectedLanguageForDropdown(surveyLanguage);
    }
  }, [surveyLanguage]);

  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          surveyLanguage
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
    }
  }, [isRightAlign, surveyLanguage]);

  useEffect(() => {
    if (selectedLanguageForDropdown) {
      setSelectedLanguage(selectedLanguageForDropdown);
      setselectedLanguageForDropdown(selectedLanguageForDropdown);
    }
  }, [selectedLanguageForDropdown]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener("input", (event) => {
        const value = (event.target as HTMLInputElement).value;
        console.log("Autofill OTP:", value);

        if (value.length === otpConfig.AUTH2FA_OTPLENGTH) {
          form.setFieldsValue({ otp: value.split("") });
        }
      });
    }
  }, []);

  const styles = {
    container: {
      margin: "0 auto",
      maxWidth: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
      textAlign: isRightAlign ? "right" : "",
    },
    mainheader: {
      height: "80px",
      padding:
        whitelabelConfig.uiSettings.logoHeightFull === true ? "0 0" : "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
      borderTop: "1px solid #cccccc",
    },
    subheaderinner: {
      maxWidth: "85%",
      padding: "20px 0 15px 0",
      margin: "0 auto",
      fontWeight: "600",
      textAlign: isRightAlign ? "right" : "",
    },
    section: {
      alignItems: "center",
      backgroundSize: "cover",
      display: "flex",
      padding: screens.md ? `${token.sizeXXL}px 0px` : "0px",
      height: "100vh",
    },
    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
    },
    footertext: {
      color: "#333",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "21px",
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
    bodycontainer: {
      maxWidth: "85%",
      margin: "0 auto",
      paddingBottom: "20px",
      textAlign: isRightAlign ? "right" : "",
    },
    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      borderRadius: "50px",
      textTransform: "uppercase",
      fontWeight: "500",
      boxShadow: "none",
    },
    containwrapper: {
      padding: "0 15px",
      display: "flex",
      width: "100%",
    },
  };
  const validateEmail = (loginEmail: string) => {
    let regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!loginEmail || loginEmail.length == 0) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_MAIL_VALIDATION1")}`,
      });
      return false;
    } else if (!regex.test(String(loginEmail).toLowerCase())) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_MAIL_VALIDATION2")}`,
      });
      return false;
    } else {
      return true;
    }
  };
  const validatePhone = (loginPhone: string) => {
    let regex = /^[0-9]{10}$/;
    if (!loginPhone || loginPhone.length == 0) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_PHONE_VALIDATION1")}`,
      });
      return false;
    } else if (!regex.test(String(loginPhone).toLowerCase())) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_PHONE_VALIDATION2")}`,
      });
      return false;
    } else {
      return true;
    }
  };
  const verifyAuthMode = (loginId: string) => {
    let authMode = identifyAuthMode(loginId);
    let isValid = true;
    if (
      (authMode == "email" && !validateEmail(loginId)) ||
      (authMode == "mobile" && !validatePhone(loginId))
    ) {
      isValid = false;
    }
    return isValid ? authMode : null;
  };
  const identifyAuthMode = (loginId: string) => {
    var emailRegex = /\S+@\S+\.\S+/;
    var phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    if (emailRegex.test(loginId)) {
      return "email";
    } else if (phoneRegex.test(loginId)) {
      return "mobile";
    } else {
      return false;
    }
  };
  const [form] = Form.useForm();
  const handleStep1 = (values: any) => {
    setIsOtpError(initialErrorState);
    let authMode = verifyAuthMode(values.email_phone);
    if (
      !values.email_phone ||
      values.email_phone == undefined ||
      values.email_phone == "" ||
      authMode == null
    ) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("AUTH2FA.ERRSTART")} ${t("AUTH2FA.ERR_NULL_EMAIL_PHONE")}`,
      });
      return;
    } else {
      isAppLoading(true);
      generateEmailPhoneOTP(values.email_phone, `${authMode}/authenticate/`)
        ?.then((res: any) => {
          console.log("res++++++", res);
          const authSession = {
            auth_progress: "PROGRESS",
            user_id: values.email_phone,
          };
          updateAuthSession(authSession);
          handleGenerateOtpRes(res);
        })
        .catch((e) => {
          setIsOtpError({
            isError: true,
            errMsg: `${t("AUTH2FA.ERRSTART")} ${t(
              "AUTH2FA.ERR_NULL_EMAIL_PHONE"
            )}`,
          });
          form.resetFields(["email_phone"]);
        });
    }
  };
  const handleGenerateOtpRes = (res: any) => {
    console.log("res?.data.Language", res?.data.Language);
    const isDisabled = res?.data?.SurveyLanguage !== 0;
    console.log("isDisabled", isDisabled);
    setIsDisabled(isDisabled);
    isAppLoading(false);
    const languageId = res.data?.SurveyLanguage;
    const language = LANGUAGES.find((lang) => lang.id === languageId);
    const memberLanguageId = res?.data.Language;
    const memberLanguage = LANGUAGES.find(
      (lang) => lang.id === memberLanguageId
    );
    ReactGA.event({
      category: "Verify OTP ",
      action: "Success API Validation ",
      label: "Auth 2fa Page",
    });

    if (language) {
      i18n.changeLanguage(language.code);
      dispatch(portalActions.updateLanguageState(language.code));
      dispatch(portalActions.updateSurveyLanguageState(language.code));
    } else if (memberLanguage) {
      i18n.changeLanguage(memberLanguage.code);
      dispatch(portalActions.updateLanguageState(memberLanguage.code));
      dispatch(portalActions.updateSurveyLanguageState(memberLanguage.code));
    }
    let uiPayloadAgreement = {
      contentTitle: t("AGREEMENT_GLOBAL.TITLE"),
      contentText: t("AGREEMENT_GLOBAL.AGREEMENT_TEXT", {
        PRODUCT_NAME: process.env.REACT_APP_PRODUCT,
      }),
      isCompleted: false,
    };
    if (res.data.SurveyLabel?.AgreementText) {
      uiPayloadAgreement = {
        contentTitle: res.data.SurveyLabel.Title,
        contentText: res.data.SurveyLabel.AgreementText,
        isCompleted: false,
      };
    }

    dispatch(portalActions.updateAgreementState(uiPayloadAgreement));
    let uiPayloadThankyou = {
      contentTitle: t("THANKYOU.TITLE"),
      contentText: t("THANKYOU.CONTENT_TEXT", {
        PRODUCT_NAME: process.env.REACT_APP_PRODUCT,
      }),
      isCompleted: false,
    };
    if (res.data.SurveyLabel?.ConfirmationText) {
      uiPayloadThankyou = {
        contentTitle: res.data.SurveyLabel.Title,
        contentText: res.data.SurveyLabel.ConfirmationText,
        isCompleted: false,
      };
    }
    dispatch(portalActions.updateThankYouState(uiPayloadThankyou));
    if (res.data.Appointment) {
      let appointmentState = {
        contentText: res.data.Appointment.AppointmentText,
        contentRef: res.data.Appointment.ContactCenterNumber,
      };
      dispatch(
        portalActions.updateAppointmentCallforwardState(appointmentState)
      );
    }
    setLocalStore("2FA_TOKEN", res.data.TokenID);
  };
  const handleFinish = (values: any) => {
    console.log("values....................", values.otp);
    const otpStr = values.otp || "";
    setIsOtpError(initialErrorState);
    if (otpStr.length !== otpConfig.AUTH2FA_OTPLENGTH) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("AUTH2FA.ERRSTART")} ${otpConfig.AUTH2FA_OTPLENGTH} ${t(
          "AUTH2FA.ERREND"
        )}`,
      });
      setOtpValues([]);
      return;
    }

    isAppLoading(true);
    let authMode = identifyAuthMode(portalAuthSessionMeta.user_id);
    const otpPromise =
      portalSessionMeta.targetComponent === "medicard"
        ? verifyMedicaidOTP(getLocalStore("2FA_TOKEN"),
          values.otp,
          authMode,
          portalAuthSessionMeta.user_id)
        : verifyOTP(
          getLocalStore("2FA_TOKEN"),
          values.otp,
          authMode,
          portalAuthSessionMeta.user_id
        );

    otpPromise
      ?.then((res: any) => {
        console.log("res_____", res);
        isAppLoading(false);
        if (res.data.Authenticated === "true") {
          const authSession = {
            auth_progress: "PROGRESS",
            access_token: res.data.Access_Token,
            user_name: res.data.MemberName,
          };
          updateAuthSession(authSession);
          if (res.data.PendingSurveys && res.data.PendingSurveys.length > 0) {
            const sessionPayload = {
              pendingSurveys: res.data.PendingSurveys,
            };
            dispatch(portalActions.updateMicrositeSession(sessionPayload));
          }
          updateAuthWizard(authStep.onSuccess);
          ReactGA.event({
            category: "Verify OTP Button Click",
            action: "Success OTP JS Vaidation",
            label: "Auth 2fa Page",
          });
          setIsOtpError(initialErrorState);
        } else {
          ReactGA.event({
            category: "Verify OTP Button Click",
            action: "Failed OTP JS Validation ",
            label: "Auth 2fa Page",
          });
          setIsOtpError({
            isError: true,
            errMsg: `${t("AUTH2FA.NUMBEROFATTEMPTSSTARTMSG")} ${res?.data?.AttemptsRemaining
              } ${t("AUTH2FA.NUMBEROFATTEMPTSENDMSG")}`,
          });
          form.resetFields(["otp"]);
          setOtpValues([]);
        }
      })
      .catch((e) => {
        console.log("catch", e);
        removeLocalStore("2FA_TOKEN");
        form.resetFields(["otp"]);
        handleErrorNavigation(e, navigate, t);
      });
  };
  const step2 = () => {
    isAppLoading(true);
    generate2faOTP()
      ?.then((res: any) => {
        console.log("res.....", res);
        handleGenerateOtpRes(res);
      })
      .catch((e) => {
        console.log("coming..", e);
        ReactGA.event({
          category: "Verify OTP ",
          action: "Failed API Validation ",
          label: "Auth 2fa Page",
        });
        handleErrorNavigation(e, navigate, t);
      });
  };
  const step1 = () => {
    if (
      portalAuthSessionMeta.user_id?.length > 0 &&
      portalAuthSessionMeta.auth_progress == "NOT-STARTED"
    ) {
      handleStep1({ email_phone: portalAuthSessionMeta.user_id });
    }
  };
  const step3 = () => {
    isAppLoading(true);
    midAuthenticatOTP()
      ?.then((res: any) => {
        console.log("res1.....", res);
        handleGenerateOtpRes(res);
      })
      .catch((e) => {
        console.log("coming..", e);
        ReactGA.event({
          category: "Verify OTP ",
          action: "Failed API Validation ",
          label: "Auth 2fa Page",
        });
        handleErrorNavigation(e, navigate, t);
      });
  };
  const handleChange = (value: string) => {
    setOtp(value);
    form.setFieldsValue({ otp: value });
  };

  const handleLanguageChange = (value: any) => {
    setSelectedLanguage(value);
    setselectedLanguageForDropdown(value);
    localStorage.setItem("preferredLanguage", value);
    i18n.changeLanguage(value); // Update i18n language
    dispatch(portalActions.updateLanguageState(value));
    dispatch(portalActions.updateSurveyLanguageState(value));
    i18n.changeLanguage(value);
  };
  const handlePaste = (event: any) => {
    const pastedData = event.clipboardData.getData("text");
    console.log("pastedData................", pastedData);
    if (pastedData.length === otpConfig.AUTH2FA_OTPLENGTH) {
      const otpArray = pastedData.split("");
      form.setFieldsValue({ otp: otpArray });
    }
  };
  console.log("isDisabled", isDisabled);
  useEffect(() => {
    sessionStorage.clear();
    logSessionDetail("OtpViewed");
    if (portalSessionMeta.urlRef) {
      if (portalSessionMeta.targetComponent === "medicard") {
        step3();
      } else {
        step2();
      }
    } else {
      step1();
    }
  }, []);
   const getSelectedLanguageLabel = (languageCode: string) => {
  const found = LANGUAGES.find(
    (lang) => lang.code === languageCode
  );

  return found ? found.label : "";
};
  return (
    <section style={styles.section} data-testid="auth-fa">
      <img
        src={BgImage}
        alt=""
        aria-hidden="true"
        style={{
          objectFit: "cover",
          position: "absolute",
          maxWidth: "100%",
          height: "100vh",
          zIndex: 0,
          width: "100%",
        }}
      />
      <div style={styles.containwrapper}>
        <div style={styles.container}>
          <div style={styles.mainheader} className="logo-header">
            <AppLogo />
          </div>
          <div style={styles.header} role={role} >
            <Text style={styles.text}   aria-label={t("AUTH2FA.DESCRIPTION", {
    HELPPHONE: process.env.REACT_APP_HELP_PHONE,
  })} id="auth-desc" tabIndex={0} role="note">
              {t("AUTH2FA.DESCRIPTION", {
                HELPPHONE: process.env.REACT_APP_HELP_PHONE,
              })}
            </Text>
          </div>
          {whitelabelConfig.uiSettings.isLandingImage && (
            <img
              src={`${whitelabelConfig.uiSettings.landingImageUrl}`}
              alt=""
              style={{ paddingBottom: "10px" }}
            />
          )}
          <div style={styles.subheader}>
            <div style={styles.subheaderinner}>
              {portalSessionMeta.urlRef && (
                <>
                  <label
                    htmlFor="select-language"
                    style={styles.text}
                    id="lang-select-desc"
                    tabIndex={0}
                    role="article"
                    // style={{
                    //   color: "#333",
                    //   fontSize: "12px",
                    //   lineHeight: "21px",
                    //   display: "block",
                    //   marginBlockStart: "1em",
                    //   marginBlockEnd: "1em",
                    // }}
                  >
                    {t("AUTH2FA.SURVEY_LANGUAGE_SELECTION_TEXT")}
                  </label>
                        <div ref={languageSelectWrapperRef}>
  <Select
    id="select-language"
    tabIndex={0}
    virtual={false}
    value={selectedLanguage}
    aria-disabled={isDisabled}
    open={isDisabled ? false : undefined}
    className={isDisabled ? "address-input-readonly" : ""}
    style={{
      width: "100%",
      marginBottom: 20,
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
      textAlign: "center",
      marginTop: 20,
      pointerEvents: isDisabled ? "none" : undefined,
    }}
    onKeyDown={(e) => {
      if (isDisabled && e.key !== "Tab") {
        e.preventDefault();
      }
    }}
    onMouseDown={(e) => {
      if (isDisabled) {
        e.preventDefault();
        e.stopPropagation();
      }
    }}
    aria-describedby="selected-language-value"
    onChange={(value) => {
      if (!isDisabled) {
        handleLanguageChange(value);
      }
    }}
    onDropdownVisibleChange={(open) => {
      if (isDisabled) return;
      syncLanguageSelectAriaControls(open);
    }}
  >
    {LANGUAGES.map((lang) => (
      <Option key={lang.code} value={lang.code} style={styles.text}>
        {lang.label}
      </Option>
    ))}
  </Select>
  <span id="selected-language-value" className="sr-only">
    {getSelectedLanguageLabel(selectedLanguage)}
  </span>
</div>
                  <div
                    id={LANGUAGE_LISTBOX_PLACEHOLDER_ID}
                    role="listbox"
                    aria-hidden="true"
                    style={{ display: "none" }}
                  />
                </>
              )}
              {(portalSessionMeta.urlRef || portalAuthSessionMeta.user_id) && (
                <Text style={styles.text} id="welcome-txt" tabIndex={0} role="article">{t("AUTH2FA.WELCOME_TEXT")}</Text>
              )}
              {!portalSessionMeta.urlRef && !portalAuthSessionMeta.user_id && (
                <Text style={styles.text} id="email-desc" tabIndex={0} role="article">{t("AUTH2FA.LABEL_EMAIL")}</Text>
              )}
            </div>
          </div>
          <div style={styles.bodycontainer}>
            {(portalSessionMeta.urlRef || portalAuthSessionMeta.user_id) && (
              <Form
                onFinish={handleFinish}
                form={form}
                initialValues={{ otp: "" }} // Initialize with empty value
              >
                <Form.Item name="otp" style={{ marginBottom: "20px" }}>
                  <OtpInput value={otp} valueLength={6} onChange={handleChange} />
                </Form.Item>

                {isOtpError.isError === true ? (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Alert message={isOtpError.errMsg} type="error" />
                  </Space>
                ) : null}

                <Form.Item style={{ marginBottom: "20px" }}>
                  <Button
                    block={true}
                    type="primary"
                    htmlType="submit"
                    style={styles.button}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    id="auth-submit-btn"
                  >
                    {t("AUTH2FA.LOGIN")}
                  </Button>
                </Form.Item>

                <Text id="footer-desc" tabIndex={0} role="article" style={styles.footertext}>{t("AUTH2FA.FOOTER")}</Text>
              </Form>
            )}
            {!portalSessionMeta.urlRef && !portalAuthSessionMeta.user_id && (
              <Form onFinish={handleStep1} form={form}>
                <Form.Item name="email_phone" style={{ marginBottom: "20px" }}>
                  <Input
                    aria-label={t("AUTH2FA.EMAIL_OR_PHONE_LABEL", { defaultValue: "Email or phone number" })}
                    style={{ height: "42px", width: "100%", fontSize: "14px" }}
                    id="email-phone-label"
                  />
                </Form.Item>
                {isOtpError.isError === true ? (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Alert message={isOtpError.errMsg} type="error" />
                  </Space>
                ) : null}
                <Form.Item style={{ marginBottom: "20px" }}>
                  <Button
                    block={true}
                    type="primary"
                    htmlType="submit"
                    style={styles.button}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    id="send-code-btn"
                  >
                    {portalSessionMeta.urlRef && t("AUTH2FA.LOGIN")}
                    {!portalSessionMeta.urlRef && t("AUTH2FA.SEND_CODE")}
                  </Button>
                </Form.Item>
                <Text id="footer-desc-1" tabIndex={0} role="article" style={styles.footertext}>{t("AUTH2FA.FOOTER")}</Text>
              </Form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default AuthPage;
